import { Edit, translate } from "react-admin";
import React from "react";

import AreainfoForm from "./AreainfoForm";

const AreainfoTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("areainfo.areainfo")}`} {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(AreainfoTitle);

export const AreainfoEdit = props => (
  <Edit title={<Title />} {...props}>
    <AreainfoForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/areainfo/AreainfoEdit.js